export const borderRadius = 10;

export const boxShadow = '0 0 10px 0 rgba(0, 0, 0, 0.16)';
